import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ReplaySubject} from "rxjs/ReplaySubject";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {AuthService} from "../../services/auth/auth.service";
import "rxjs/add/operator/takeUntil";
import { FeatureFlagService } from 'app/shared/services/feature-flag';

@Component({
  selector: 'app-report-details-modal',
  templateUrl: './report-details-modal.component.html',
  styleUrls: ['./report-details-modal.component.scss']
})
export class ReportDetailsModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("content") template: TemplateRef<any>;
  modalTitle: string = "Genalyte Reports";
  modalRef: NgbModalRef;
  navigateUrl;
  reports: Report[] = [];
  user: User;

  private destroyed: ReplaySubject<boolean> = new ReplaySubject(1);

  private options: NgbModalOptions = {
    backdrop: "static",
    windowClass: "report-details-modal",
    container: "app-report-details-modal",
    size: "lg",
    keyboard: false
  };

  constructor(public router: Router,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private authService: AuthService,
              private featureFlag: FeatureFlagService,
              private store: Store<any>) {

  }

  ngOnInit() {
    this.user = this.authService.getUser();
    this.route.data.takeUntil(this.destroyed).subscribe((data: { forPatient: boolean, order: Order, navigateUrl: string }) => {
      this.featureFlag.hide_extra_reports.asObservable().subscribe(hide_report => {
        if (hide_report) {
          this.reports = data.order.Attachments.filter(report => report.TagList.includes("final_results_report"));
        } else {
          this.reports = data.order.Attachments;
        }
      })

      this.navigateUrl = data.navigateUrl;
      if (data.forPatient) {
        this.store.select("patient").takeUntil(this.destroyed).subscribe(patient => {

          if (patient) {
            this.modalTitle = `Genalyte Reports for ${patient.FirstName} ${patient.LastName}`
          }
        });
      }
    })
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
  }

  cancel() {
    this.destroy();
    this.back();
  }

  destroy() {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  back() {
    // setTimeout acting as a noop because the above observable does not take into effect
    // soon enough to block passage through .takeUntil()
    setTimeout(() => {
      this.router.navigate(this.navigateUrl);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.options);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/report-details-modal/report-details-modal.component.ts